import { supabase } from '@/lib/supabase'

export const getImpersonationContext = () => {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')
  const targetUserId = params.get('impersonate') || undefined
  const orgId = params.get('org') || undefined
  const sessionId = localStorage.getItem('impersonation_session_id') || undefined
  return { targetUserId, orgId, sessionId }
}

export const isImpersonating = (actorEmail?: string) => {
  const { targetUserId } = getImpersonationContext()
  return !!targetUserId && !!actorEmail && actorEmail.toLowerCase().includes('admin')
}

export const startImpersonationLog = async (actorUserId?: string, actorEmail?: string, targetUserId?: string, targetEmail?: string, orgId?: string) => {
  try {
    const sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem('impersonation_session_id', sessionId)
    await supabase.from('impersonation_logs').insert({
      session_id: sessionId,
      actor_user_id: actorUserId,
      actor_email: actorEmail,
      target_user_id: targetUserId,
      target_email: targetEmail,
      org_id: orgId,
      action: 'start',
      path: window.location.pathname
    })
  } catch {}
}

export const logImpersonationAction = async (action: string, metadata?: any) => {
  try {
    const { sessionId } = getImpersonationContext()
    if (!sessionId) return
    await supabase.from('impersonation_logs').insert({
      session_id: sessionId,
      action,
      path: window.location.pathname,
      metadata
    })
  } catch {}
}

export const endImpersonationLog = async () => {
  try {
    const { sessionId } = getImpersonationContext()
    if (!sessionId) return
    await supabase.from('impersonation_logs').insert({ session_id: sessionId, action: 'end', path: window.location.pathname })
    localStorage.removeItem('impersonation_session_id')
  } catch {}
}

